<template>
  <card>
    <h5
      slot="header"
      class="card-title"
    >
      Announcements
    </h5>
    <div
      :class="{draft: !a.DateOf}"
      class="card card-plain pb-2 mb-0"
      :name="a.Id"
      v-for="a in announcements"
      :key="a.Id"
      style="border-bottom: 1px solid rgba(0, 0, 0, 0.125)"
    >
      <div class="card-header">
        <div class="row">
          <div class="col-1 d-flex align-items-start">
            <i
              class="bi bi-signpost-2"
              style="font-size: 2.2em;transform: none !important;color: #f96332"
            />
          </div>
          <div class="col-6">
            <b>{{ a.Headline }}</b><br><span class="ml-3">{{ formatDateOf(a.DateOf) }}</span>
          </div>
          <div class="col-1 d-flex align-items-start">
            <el-dropdown
              v-if="a.Links.length > 0"
              trigger="click"
              @command="showLink"
            >
              <span class="el-dropdown-link">
                <i
                  class="bi bi-paperclip"
                  style="font-size: 2.2em;transform: none !important;color: #f96332"
                />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  :command="l.LinkUrl"
                  v-for="l in a.Links"
                  :key="l.Id"
                >
                  {{ l.Headline }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="col-2">
            <i
              v-if="a.IsForParticipant"
              class="bi bi-check-square-fill"
              style="font-size: 1.5em;transform: none !important;color: #66615B"
            />
            <i
              v-else
              class="bi bi-square-fill"
              style="font-size: 1.5em;transform: none !important;color: #66615B"
            />
            <span class="ml-2">Participants</span>
            <i
              v-if="a.IsForStaff"
              class="bi bi-check-square-fill"
              style="font-size: 1.5em;transform: none !important;color: #66615B"
            />
            <i
              v-else
              class="bi bi-square-fill"
              style="font-size: 1.5em;transform: none !important;color: #66615B"
            />
            <span class="ml-2">Staff</span>
          </div>
          <div class="col-2 d-flex justify-content-end align-items-center">
            <p-button
              type="info"
              size="sm"
              class="mt-1 mb-1"
              title="Edit"
              icon
              @click="showEditDialog(a)"
            >
              <i class="fa fa-edit" />
            </p-button>
            <p-button
              type="danger"
              size="sm"
              class="mt-1 mb-1 ml-1"
              title="Delete"
              icon
              @click="deleteConfirm(a)"
            >
              <i class="fa fa-times" />
            </p-button>
          </div>
        </div>
      </div>
    </div>
    <modal
      :show.sync="showEdit"
      class="modal-primary"
      :show-close="false"
      header-classes="justify-content-center"
      modal-classes="wide-dialog"
    >
      <div
        slot="header"
        class="ml-4"
      >
        <h6>
          <i class="fa fa-edit mr-2" />
          <span class="text-danger">{{ editAnnouncement.Id ? "Edit" : "Add" }} Announcement</span>
        </h6>
      </div>
      <fg-input
        name="title"
        label="Title"
        placeholder=""
        required
        max-length="150"
        v-model="editAnnouncement.Headline"
      />
      <div class="row">
        <div class="mt-2 mb-2 col-6">
          <label for="description">Recipients</label>
          <p-checkbox
            class="ml-2"
            v-model="editAnnouncement.IsForParticipant"
          >
            <span style="color:#66615B !important">Participants</span>
          </p-checkbox>
          <p-checkbox
            class="ml-2"
            v-model="editAnnouncement.IsForStaff"
          >
            <span style="color:#66615B !important">Staff Members</span>
          </p-checkbox>
        </div>
        <div class="mt-2 mb-2 col-6">
          <announcement-attachments
            :list="editAnnouncement.Links"
            :announcement-id="editAnnouncement.Id"
            @attachmentsChanged="attachmentsChanged"
            @dialogClosed="attachmentDialogClosed"
          />
        </div>
      </div>
      <fg-input>
        <label for="description">Contents</label>
        <ckeditor
          :editor="editor"
          v-model="editAnnouncement.Contents"
          :config="editorConfig"
        />
      </fg-input>
      <template slot="footer">
        <p-button
          type="danger"
          class="mr-2"
          @click="showEdit = false"
        >
          Close
        </p-button>
        <p-button
          type="success"
          class="mr-2"
          :disabled="!editAnnouncement.Headline || (!editAnnouncement.IsForParticipant && !editAnnouncement.IsForStaff)"
          @click="save"
        >
          Save
        </p-button>
        <p-button
          type="primary"
          class="ml-4 mr-2"
          @click="publishConfirm"
        >
          Publish
        </p-button>
      </template>
    </modal>
    <button
      type="button"
      class="btn btn-success"
      @click="showAddNewDialog"
    >
      Add New
    </button>
  </card>
</template>

<script>
import announcementApi from '@/services/api/announcement.js'
import formatter from '@/services/formatter.js'
import Modal from '@/plugins/paper-components/modal.vue'
import CKEditor from '@ckeditor/ckeditor5-vue'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import PCheckbox from '@/plugins/paper-components/inputs/p-checkbox.vue'
import AnnouncementAttachments from '@/components/announcements/announcement-attachments.vue'

export default {
  name: 'AnnouncementsEdit',
  components: {
    Modal,
    ckeditor: CKEditor.component,
    PCheckbox,
    AnnouncementAttachments
  },
  data: function () {
    return {
      announcements: [],
      showEdit: false,
      editAnnouncement: {},
      editorConfig: {},
      editor: ClassicEditor
    }
  },
  mounted: function () {
    this.getData()
  },
  methods: {
    getData: function () {
      announcementApi.get(this.$root.courseKey, true, true, true)
        .then(x => {
          this.announcements = x
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    },
    formatDateOf: function (value) {
      if (value !== null) {
        return formatter.formatAsDateTime(value)
      } else {
        return 'Not Published'
      }
    },
    showLink: function (linkUrl) {
      window.open(linkUrl, '_blank')
    },
    showEditDialog: function (announcement) {
      this.editAnnouncement = announcement
      this.showEdit = true
    },
    showAddNewDialog: function () {
      this.editAnnouncement = {
        CourseKey: this.$root.courseKey,
        IsDraft: true,
        AnnouncementType: 3,
        IsForParticipant: false,
        IsForStaff: false,
        Headline: '',
        Contents: ''
      }
      this.showEdit = true
    },
    deleteConfirm: function (announcement) {
      const msg = 'Are you sure you want to delete ' + announcement.Headline + '?'
      this.$confirm(msg, 'Are you sure?')
        .then(() => {
          this.deleteAnnouncement(announcement)
        })
    },
    deleteAnnouncement: function (announcement) {
      announcementApi.delete(this.$root.courseKey, announcement.Id)
        .then(x => {
          this.announcements = x
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error deleting your announcement.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(z => {
        })
    },
    attachmentsChanged: function () {
      announcementApi.getAttachments(this.editAnnouncement.Id)
        .then(x => {
          this.editAnnouncement.Links = x
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(z => {
          this.attachmentDialogClosed()
        })
    },
    attachmentDialogClosed: function () {
      if (!document.body.classList.contains('modal-open')) {
        document.body.classList.add('modal-open')
      }
    },
    save: function () {
      announcementApi.update(this.$root.courseKey, this.editAnnouncement)
        .then(x => {
          this.announcements = x
          this.setEditId()
          this.$notify({
            message: 'Update Complete',
            icon: 'nc-icon nc-satisfied',
            type: 'success',
            horizontalAlign: 'center',
            timeout: 2000
          })
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error updating your announcement.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(z => {
        })
    },
    publishConfirm: function () {
      const msg = 'Are you sure you want to send out the announcement: ' + this.editAnnouncement.Headline + '?'
      this.$confirm(msg, 'Are you sure?')
        .then(() => {
          this.publish()
        })
    },
    publish: function () {
      announcementApi.publish(this.$root.courseKey, this.$root.scouterKey, this.editAnnouncement)
        .then(x => {
          this.announcements = x
          this.setEditId()
          this.$notify({
            message: 'Publish Complete',
            icon: 'nc-icon nc-satisfied',
            type: 'success',
            horizontalAlign: 'center',
            timeout: 2000
          })
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error publishing your announcement.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(z => {
        })
    },
    setEditId: function () {
      if (this.editAnnouncement.Id === undefined || this.editAnnouncement.Id === null || this.editAnnouncement.Id === 0) {
        this.editAnnouncement.Id = 0
        for (let i = 0; i < this.announcements.length; i++) {
          if (this.announcements[i].Headline === this.editAnnouncement.Headline &&
                this.announcements[i].Id > this.editAnnouncement.Id) {
            this.editAnnouncement.Id = this.announcements[i].Id
          }
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .draft {
    background-color: #999999 !important;
  }
</style>
<style scoped>
.wide-dialog {
    max-width: 1000px !important;
  }
</style>
